/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import {
  isAfterDate,
  isBeforeDate,
  isSameDate,
  getNewDate,
} from '../../shared/helper-utils/appUtils';
import { TODAY_DATE } from '../../shared/constants/Constants';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import { debounce } from '../../api/apiUtils';
import FlightListCard from './FlightListCard';

const UPCOMING = 'upcoming';
const CANCELLED = 'cancelled';
const COMPLETED = 'completed';
const UNSUCCESSFUL = 'unsuccessful';
const ALL = 'all';

const iconStyle = { fontSize: 22, marginRight: 8, color: '#374471' };

function FlightBookingList({ flightBookings }) {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const [searchText, setSearchText] = useState('');
  const [transactionsList, setTransactionsList] = useState([]);
  const [upcomingList, setUpcomingList] = useState([]);
  const [cancelledList, setCancelledList] = useState([]);
  const [completedList, setCompletedList] = useState([]);
  const [pendingList, setPendingList] = useState([]);
  const [selectedTab, setSelectedTab] = useState(UPCOMING);
  const [showTransactionsList, setShownTransactionsList] =
    useState(upcomingList);
  const [allTransactionsList, setAllTransactionsList] = useState([]);

  const resetData = () => {
    setSearchText('');
    setTransactionsList([]);
    setUpcomingList([]);
    setCancelledList([]);
    setCompletedList([]);
    setPendingList([]);
    setSelectedTab(UPCOMING);
    setShownTransactionsList(upcomingList);
  };

  useEffect(() => {
    resetData();
    setTransactionsList(flightBookings);
  }, [flightBookings]);

  useEffect(() => {
    const canxList = transactionsList.filter(
      (transaction) =>
        transaction.FlightRecord.BookingStatus.toLowerCase() === 'cancelled',
    );
    const pList = transactionsList.filter(
      (transaction) =>
        ['cancelled', 'confirmed'].indexOf(
          transaction.FlightRecord.BookingStatus.toLowerCase(),
        ) === -1,
    );
    const confirmedList = transactionsList.filter(
      (transaction) =>
        transaction.FlightRecord.BookingStatus.toLowerCase() === 'confirmed',
    );
    const upList = confirmedList.filter((transaction) => {
      const JourneyDate = getNewDate(transaction.FlightRecord.JDate);
      const isUpComing =
        isAfterDate(JourneyDate, getNewDate(TODAY_DATE)) ||
        isSameDate(JourneyDate, getNewDate(TODAY_DATE));
      return isUpComing;
    });
    const overList = confirmedList.filter((transaction) => {
      const JourneyDate = getNewDate(transaction.FlightRecord.JDate);
      const isAfter =
        isBeforeDate(JourneyDate, getNewDate(TODAY_DATE)) &&
        !isSameDate(JourneyDate, getNewDate(TODAY_DATE));
      return isAfter;
    });
    setUpcomingList(upList);
    setCancelledList(canxList);
    setPendingList(pList);
    setCompletedList(overList);
    setAllTransactionsList(transactionsList);
    if (selectedTab === UPCOMING) {
      setShownTransactionsList(upList);
    } else if (selectedTab === CANCELLED) {
      setShownTransactionsList(canxList);
    } else if (selectedTab === COMPLETED) {
      setShownTransactionsList(overList);
    } else if (selectedTab === UNSUCCESSFUL) {
      setShownTransactionsList(pList);
    } else if (selectedTab === ALL) {
      setShownTransactionsList(transactionsList);
    }
  }, [transactionsList]);

  const getShownResults = () => {
    if (selectedTab === UPCOMING) {
      setShownTransactionsList(upcomingList);
    } else if (selectedTab === CANCELLED) {
      setShownTransactionsList(cancelledList);
    } else if (selectedTab === COMPLETED) {
      setShownTransactionsList(completedList);
    } else if (selectedTab === UNSUCCESSFUL) {
      setShownTransactionsList(pendingList);
    } else if (selectedTab === ALL) {
      setShownTransactionsList(allTransactionsList);
    }
  };

  useEffect(() => {
    getShownResults();
  }, [selectedTab]);

  const setSearchResults = debounce((val) => {
    let data = [...flightBookings];
    if (val !== '') {
      data = data.filter((o) =>
        Object.keys(o.FlightRecord).some(
          (k) =>
            o.FlightRecord[k] !== null &&
            o.FlightRecord[k] !== undefined &&
            o.FlightRecord[k]
              .toString()
              .toLowerCase()
              .includes(val.toLowerCase()),
        ),
      );
    }
    setTransactionsList(data);
  }, 500);
  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    setSearchResults(value);
  };

  return (
    <section className="flight-booking-list-page">
      <div className="train-search-container hide-in-mobile">
        <div className="mb-3 d-flex justify-content-end">
          <div style={{ width: '300px' }}>
            <AppTextInput
              value={searchText}
              label={formattedMessage('search')}
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
      <div className="d-flex gap-2 flight-booking-list-page_transactions-type-container overflow-auto">
        <span
          onClick={() => setSelectedTab(UPCOMING)}
          className={`${selectedTab === UPCOMING ? 'selected-tx-tab' : ''}`}
        >
          Upcoming({upcomingList.length})
        </span>
        <span
          onClick={() => setSelectedTab(COMPLETED)}
          className={`${selectedTab === COMPLETED ? 'selected-tx-tab' : ''}`}
        >
          Completed({completedList.length})
        </span>
        <span
          onClick={() => setSelectedTab(CANCELLED)}
          className={`${selectedTab === CANCELLED ? 'selected-tx-tab' : ''}`}
        >
          Cancelled({cancelledList.length})
        </span>
        <span
          onClick={() => setSelectedTab(UNSUCCESSFUL)}
          className={`${selectedTab === UNSUCCESSFUL ? 'selected-tx-tab' : ''}`}
        >
          Unsuccessful({pendingList.length})
        </span>
        <span
          onClick={() => setSelectedTab(ALL)}
          className={`${selectedTab === ALL ? 'selected-tx-tab' : ''}`}
        >
          All({allTransactionsList.length})
        </span>
      </div>
      {showTransactionsList.length > 0 ? (
        <div>
          {showTransactionsList.map((transaction, index) => (
            <FlightListCard
              key={`${transaction.FlightRecord.Txid}_${index}`}
              transaction={transaction}
              txType={selectedTab}
            />
          ))}
        </div>
      ) : (
        <div className="p-3 text-center fw-500">
          <span>No Bookings</span>
        </div>
      )}
    </section>
  );
}

export default FlightBookingList;
